import React from 'react';
import SectionShell from '../SectionShell';
import Reveal from '../Reveal';
import FlickerNumber from '../FlickerNumber';
import GrowthChart from '../GrowthChart';
import { useT } from '../../i18n/LanguageContext';

// Diamond market volume projection (2024 → 2030), USD Bn.
// Interpolated linearly between the reported endpoints 99 → 108.
const MARKET_POINTS = [
  { x: '2024', y: 99 },
  { x: '2025', y: 100.5 },
  { x: '2026', y: 102 },
  { x: '2027', y: 103.8 },
  { x: '2028', y: 105.3 },
  { x: '2029', y: 106.7 },
  { x: '2030', y: 108 },
];

export default function SectionMarkt() {
  const { t } = useT();
  return (
    <SectionShell id="markt" data-section-label="Marktvolumen">
      <div className="text-center w-full">
        <Reveal>
          <div className="overline mb-4">{t.markt.overline}</div>
        </Reveal>
        <Reveal delay={120}>
          <div className="font-display tracking-tighter leading-none text-white mb-3" data-testid="markt-value">
            <span className="text-5xl md:text-6xl lg:text-7xl">
              <FlickerNumber value={99} duration={1600} />
            </span>
            <span className="text-4xl md:text-5xl text-white/60 ml-3">
              — <FlickerNumber value={108} duration={1900} />
            </span>
            <div className="font-ui text-xs md:text-sm tracking-[0.4em] uppercase text-white/40 mt-3">{t.markt.unit || 'USD Mrd.'}</div>
          </div>
        </Reveal>

        <Reveal delay={250}>
          <p className="font-display text-xl md:text-2xl text-white/70 mb-6">{t.markt.sub}</p>
        </Reveal>

        {/* Animated growth chart 2024 → 2030 — big & prominent */}
        <Reveal delay={350}>
          <div className="mt-2 mb-6 markt-chart-wrap">
            <GrowthChart
              points={MARKET_POINTS}
              yMin={96}
              yMax={110}
              yLabel={t.markt.unit || 'USD Mrd.'}
              unit=""
              accent="gold"
            />
          </div>
        </Reveal>

        <Reveal delay={450}>
          <p className="font-ui text-xl md:text-2xl text-white/70 max-w-[80ch] mx-auto leading-relaxed" data-testid="markt-forecast">
            {t.markt.forecast}
          </p>
          <div className="overline mt-4 text-white/40 text-base">{t.markt.source}</div>
        </Reveal>
      </div>
    </SectionShell>
  );
}
